import { render } from "./SaveDisplay.vue?vue&type=template&id=cbcd917c&scoped=true&ts=true"
import script from "./SaveDisplay.vue?vue&type=script&lang=ts"
export * from "./SaveDisplay.vue?vue&type=script&lang=ts"

import "./SaveDisplay.vue?vue&type=style&index=0&id=cbcd917c&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbcd917c"]])

export default __exports__